export default __webpack_public_path__ + "static/media/walletConnect.538cd220.svg";